import {Box, Grid, Typography} from '@mui/material';

interface Props {
  status: string;
  count: number;
  borderColour: string;
}

export const ApplicantsCounter = ({status, count, borderColour}: Props) => {
  return (
    <Box
      sx={{
        width: {xs: '100%', md: '260px'},
        height: '60px',
        borderLeft: `4px solid ${borderColour}`,
        mb: {xs: 1, md: 0},
      }}
    >
      <Grid item xs={12} ml={2}>
        <Typography variant='body1'>{status}</Typography>
      </Grid>
      <Grid item xs={12} ml={2}>
        <Typography variant='h4'>{count}</Typography>
      </Grid>
    </Box>
  );
};
